import { routePathToRegex } from "@thalamos/common";

import { createRoute } from "./createRoute.js";

/**
 * Paths that render before a session context has been settled.
 *
 * Everything else under the authenticated tree waits for the session-context
 * gate, so a page can assume it is acting as something. The gate settles *which
 * organisation* a request acts for, and a person's own account is not held on
 * behalf of one — so an account holding no membership would otherwise be unable
 * to reach its own name.
 *
 * Derived from the path builders, so a route that moves takes its entry with it
 * — as `reloadSafeRoutes` is.
 *
 * Adding a path here claims the page needs no organisation chosen before it
 * means anything. Almost nothing qualifies: an assessment belongs to an
 * organisation, so a page showing one does not.
 */
export const SESSION_CONTEXT_FREE_ROUTE_PATHS = [
  createRoute.profile(),
] as const;

const SESSION_CONTEXT_FREE_PATTERNS =
  SESSION_CONTEXT_FREE_ROUTE_PATHS.map(routePathToRegex);

/** Whether the page at this path renders before a session context has been settled. */
export const rendersWithoutSessionContext = (pathname: string): boolean =>
  SESSION_CONTEXT_FREE_PATTERNS.some((pattern) => pattern.test(pathname));
